<template>
  <div class="add-expert">

    <p style="font-size: 16px; background-color: #fff;padding: 10px;">专家信息</p>
    <van-field clickable name="realName" required label="姓名" placeholder="请输入姓名" v-model="formData.realName"
      input-align="right" error-message-align="right" :error-message="validate.fieldMsg.realName" />
    <van-field clickable name="tel" required label="手机号码" :disabled="inviteStatus == 1" placeholder="请输入手机号码"
      v-model="formData.tel" input-align="right" error-message-align="right" @change="validate.tel('tel')">
      <template #button v-if="this.inviteStatus != 1">
        <span size="small" round @click="sendCode" style="color: #6cdd8f">{{ sendClip ? "发送验证码" : `${second}s` }}</span>
      </template>
    </van-field>
    <van-field clickable name="code" v-if="this.inviteStatus != 1" required label="验证码" placeholder="请输入验证码"
      v-model="formData.code" input-align="right" error-message-align="right" :error-message="validate.fieldMsg.code" />
    <van-field clickable name="password" required v-if="this.inviteStatus != 1" label="登录密码" placeholder="请输入登录密码"
      v-model="formData.password" input-align="right" error-message-align="right"
      :error-message="validate.reg_verify_err.pwd" @change="validate.pwd('password')" />
    <van-field readonly input-align="right" clickable name="sex" required :value="sex" label="性别" placeholder="请选择性别"
      @click="showSex = true" error-message-align="right" :error-message="validate.fieldMsg.sex" />
    <van-popup v-model="showSex" position="bottom">
      <van-picker show-toolbar :columns="[
        {
          text: '男',
          value: 0
        },
        {
          text: '女',
          value: 1
        },
      ]" @confirm="onConfirmSex" @cancel="showSex = false" />
    </van-popup>
    <!-- <van-field readonly input-align="right" clickable name="city" required :value="city" label="通讯地址"
      placeholder="请选择地址" @click="showArea = true" error-message-align="right"
      :error-message="validate.fieldMsg.contactCity" />
    <van-popup v-model="showArea" position="bottom">
      <van-area :area-list="areaList" @confirm="areaConfirm" @cancel="showArea = false" />
    </van-popup>
    <van-field clickable name="contactAddress" required v-model="formData.contactAddress" label="详细地址"
      placeholder="请输入详细地址" input-align="right" error-message-align="right"
      :error-message="validate.fieldMsg.contactAddress" /> -->
    <van-field input-align="right" readonly clickable name="majorIds" required :value="major" label="选择专业"
      placeholder="请选择专业" @click="majorShow = true" error-message-align="right"
      :error-message="validate.fieldMsg.majorIds" />
    <van-popup v-model="majorShow" position="bottom">
      <van-picker show-toolbar :columns="majorColumns" @confirm="majorConfirm" @cancel="majorShow = false" />
    </van-popup>
    <van-field clickable name="synopsis" required v-model="formData.synopsis" autosize rows="4" type="textarea"
      maxlength="300" label="专家简介" placeholder="请输入简介" show-word-limit input-align="right"
      :error-message="validate.fieldMsg.synopsis" error-message-align="right" :style="{ marginBottom: '20px' }" />

    <van-field label-class="affixs-label" required>
      <template #label>
        <span class="custom-title" error-message-align="right" :error-message="validate.fieldMsg.userImg">专家头像</span>
        <span class="custom-tit" style="margin-left: 10px;">(jpg/png格式最多一张，每张不超过1M)</span>
      </template>
    </van-field>
    <div class="expert-userImg">
      <van-uploader :before-delete="userImgBeforeDel" v-model="userImg" :max-count="1"
        :before-read="compressUploadBeforeRead" />
    </div>



    <div class="create">
      <van-button size="large" @click="commitInfo" color="linear-gradient(to right, #5DD682, #5AFF8E)">提交</van-button>
    </div>
    <Crop :popup.sync="compressShow" :img="compressImg" @close="cancelUpload" @getImageData="uploaduserImg" />
  </div>
</template>

<script>
import { areaList } from "@vant/area-data";



import {
  getJudgeTelCode,
  commitInviteJudge,
  getAllMajor,
  getJudgeInfo,
} from "@/utils/api/invite";


import { uploadImg } from "@/utils/api/user";
import { checkUploadFile } from "@/utils/tool";
import { validate } from "@/utils/mixin/validate";
import Crop from "@/components/pub/CompressCrop.vue";
export default {
  mixins: [validate],
  components: {
    Crop
    // SignTitle
  },
  data() {
    return {
      sendClip: true,
      second: 60,
      formData: {
        activityId: '',
        channelId: '',
        name: '',
        tel: '',
        code: '',
        password: '',
        contactAddress: '',
        contactArea: '',
        contactCity: '',
        contactProvince: '',
        userImg: '',
        synopsis: '',
        delegateName: '',
        delegateTel: '',
        delegateAddress: '',
        delegateWechatNum: '',
        inviteCode: '',
        zoneId: '',
      },
      showSex: false,
      sex: '',
      majorShow: false,
      majorColumns: [],
      major: '',
      inviteStatus: '',
      // 省市区
      city: "",
      // 区域树
      areaList,
      // 显示区域选择
      showArea: false,
      // 头像
      userImg: [],

      // 专业列表
      majorList: [],
      // 活动列表
      activityList: [],
      // 性别
      sex: null,
      // 显示选择框
      showPicker: false,
      // 所选专业
      major: null,
      // 所选专业
      majorSelectList: [],
      // 所选活动
      activity: null,
      // 所选活动
      activityIdList: [],
      // 显示选择
      majorPicker: false,
      // 显示活动选择
      activityPicker: false,
      // 标签
      tags: [],
      mode: 0, // 0新增，1修改
      compressShow: false,
      compressImg: ""
    };
  },
  mounted() {
    this.validate.setFormDataKey("formData");

    this.formData.inviteCode = this.$route.query.inviteCode
    this.formData.channelId = this.$route.query.channelId

    this.getAllMajorData()
    this.getInfo()
  },
  methods: {
    // 获取邀请信息
    getInfo() {
      getJudgeInfo({ code: this.formData.inviteCode }).then((res) => {
        if (res.success) {
          console.log(res.data.inviteStatus)
          this.inviteStatus = res.data.inviteStatus
          var data = res.data
          if (this.inviteStatus == 1) {
            this.formData = {
              inviteCode: this.$route.query.inviteCode,
              activityId: data.activityId,
              realName: data.realName,
              channelId: data.channelId,
              name: data.name,
              tel: data.realTel,
              code: data.code,
              sex: data.sex,
              majorIds: data.majorIds,
              // 详情不赋值密码
              // password: data.password,
              // contactAddress: data.contactAddress,
              // contactArea: data.contactArea,
              // contactCity: data.contactCity,
              // contactProvince: data.contactProvince,
              userImg: data.userImg,
              synopsis: data.synopsis,
              delegateName: data.delegateName,
              delegateTel: data.delegateTel,
              delegateAddress: data.delegateAddress,
              delegateWechatNum: data.delegateWechatNum,
              zoneId: data.zoneId,

            }

            this.userImg = [{
              url: data.userImg,
              status: 'done'
            }]

            this.major = data.majors
            this.sex = data.sex == 0 ? '男' : '女'
            // this.city = data.contactProvince + data.contactCity + data.contactArea
          }

        }
      });
    },

    getAllMajorData() {

      console.log('th =', this.formData.channelId)
      // 获取专业 组别
      getAllMajor({
        channelId: this.formData.channelId
      }).then((res) => {
        if (res.success) {
          let data = res.data;
          data = data.map((e) => {
            return {
              text: e.name,
              value: e.id,

            };
          });
          this.majorColumns = data

        }
      });
    },


    // 专业确定
    majorConfirm(item) {
      this.major = item.text;
      this.formData.majorIds = item.value;
      this.majorShow = false;
    },

    // 发送验证码
    sendCode() {
      if (!this.sendClip) {
        return;
      }
      if (!(this.formData.tel && this.formData.tel.length == 11)) {
        this.$root.$toast.fail("请输入正确的手机号码！");
        return;
      }
      getJudgeTelCode({ tel: this.formData.tel }).then((res) => {
        if (res.success) {
          this.sendClip = false;
          this.codeInterval();
        }
      });
    },
    // 倒计时
    codeInterval() {
      this.itv = setInterval(() => {
        this.second--;
        if (!this.second) {
          this.second = 60;
          this.sendClip = true;
          window.clearInterval(this.itv);
        }
      }, 1000);
    },




    //
    onConfirmSex(item) {
      this.sex = item.text;
      this.formData.sex = item.value;

      this.showSex = false;
    },

    // 删除照片
    userImgBeforeDel() {
      this.formData.userImg = null;
      return true;
    },
    cancelUpload() {
      this.compressShow = false;
      this.userImg = [];
    },
    // 上传头像
    async uploaduserImg(file) {
      const pass = checkUploadFile({ file, size: 1 }, (err) => {
        this.$root.$toast.fail(err);
        this.userImg = [
          {
            url: "",
            message: "图片大于1m，请重新选择图片。",
            status: "failed",
            name: file.name
          }
        ];
      });
      if (!pass) {
        return;
      }
      this.userImg = [
        {
          url: "",
          status: "uploading",
          message: "上传中...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      let upimgobj = new FormData();
      this.$root.$toast.loading({
        message: "上传图片中……",
        duration: 0
      });
      upimgobj.append("file", file);
      const { data: url, success } = await uploadImg(upimgobj);
      if (success) {
        this.userImg = [
          {
            url,
            status: "done",
            name: file.name
          }
        ];
        this.formData.userImg = url;
      } else {
        this.userImg = [
          {
            url: "",
            message: "上传失败，请重新上传",
            status: "failed",
            name: file.name
          }
        ];
      }
      this.$forceUpdate();
      this.$root.$toast.clear();
    },
    // 上传前预处理
    uploadBeforeRead(file) {
      const pass = checkUploadFile({ file, size: 1 }, (err) => {
        this.$root.$toast.fail(err);
      });
      if (!pass) {
        return false;
      }
      this.userImg = [
        {
          url: "",
          status: "uploading",
          message: "上传中..."
        }
      ];
      let upimgobj = new FormData();
      upimgobj.append("file", file);
      uploadImg(upimgobj).then(({ success, data: url }) => {
        if (success) {
          this.userImg = [
            {
              url,
              status: "done"
            }
          ];
          this.formData.userImg = url;
          return success;
        } else {
          this.userImg = [
            {
              url: "",
              message: "上传失败，请重新上传",
              status: "failed"
            }
          ];
          return false;
        }
      });
    },
    // 压缩上传预处理
    compressUploadBeforeRead(file) {
      this.compressImg = URL.createObjectURL(file);
      this.userImg = [
        {
          url: "",
          status: "uploading",
          message: "图片编辑...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      this.compressShow = true;
    },

    // 区域确定
    areaConfirm(values) {
      this.city = `${values[0].name} ${values[1].name} ${values[2].name}`;
      this.formData.contactProvince = values[0].name;
      this.formData.contactCity = values[1].name;
      this.formData.contactArea = values[2].name;
      this.showArea = false;
    },

    commitInfo() {

      if (!this.formData.realName) {
        this.$root.$toast.fail("请填写姓名");
        return;
      }

      if (!(this.formData.tel && this.formData.tel.length == 11)) {
        this.$root.$toast.fail("请填写正确手机号");
        return;
      }

      if (!this.formData.code && this.inviteStatus != 1) {
        this.$root.$toast.fail("请填写验证码");
        return;
      }

      if (!this.formData.password && this.inviteStatus != 1) {
        this.$root.$toast.fail("请填写登录密码");
        return;
      }
      if (this.formData.sex != 0 && this.formData.sex != 1) {
        this.$root.$toast.fail("请选择性别");
        return;
      }

      // if (!this.formData.contactArea) {
      //   this.$root.$toast.fail("请选择地址");
      //   return;
      // }
      // if (!this.formData.contactAddress) {
      //   this.$root.$toast.fail("请填写详细地址");
      //   return;
      // }
      if (!this.formData.majorIds) {
        this.$root.$toast.fail("请选择专业");
        return;
      }
      if (!this.formData.synopsis) {
        this.$root.$toast.fail("请填写简介");
        return;
      }
      if (!this.formData.userImg) {
        this.$root.$toast.fail("请上传头像");
        return;
      }

      var data = JSON.parse(JSON.stringify(this.formData));
      if ((data.tel || '').indexOf('*') > -1) {
        delete data.tel
      }
      if ((data.delegateTel || '').indexOf('*') > -1) {
        delete data.delegateTel
      }

      commitInviteJudge({
        url: this.inviteStatus == 1 ? 'inviteJudge/applyInviteUpdate' : "inviteJudge/applyInvite",
        ...data
      }).then(res => {
        console.log(res)
        if (res.success) {
          this.$root.$toast.success('您已提交成功,请等待管理员审核');
        }
      })
    },





  },

};
</script>

<style lang="scss" scoped>
.add-expert {
  overflow: hidden;
  background: #f2f2f2;
  min-height: 100vh;
  .tags {
    .van-tag {
      height: 32px;
      margin-left: 3px;
      margin-bottom: 3px;
      border-radius: 4px;
      border: #f2f2f2;
      min-width: 60px;
      background-color: #ecf5ff;
      color: #666;
      font-size: 12px;
      text-align: center;
      display: inline-block;
      line-height: 26px;
    }
  }

  .create {
    margin: 0 auto;
    width: 254px;
    margin-top: 40px;
    margin-bottom: 60px;

    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/css/customer.scss";

.add-expert {
  text-align: left;

  .van-cell {
    &::after {
      border: none;
    }
  }

  .van-uploader {
    @include from-upload-style;
  }

  .custom-title {
    color: #646566;
  }

  .custom-tit {
    font-size: 12px;
    color: #ccc;
  }

  .expert-userImg {
    text-align: left;
    padding-top: 10px;
    padding-left: 10px;
    background: #fff;
  }

  .custom-span {
    color: #ccc;
  }

  .affixs-label {
    width: unset;

    &+.van-field__value {
      display: none;
    }
  }
}
</style>
